import './_hatbox-product-option.scss';
import component from './hatbox-product-option';

export default component;
